/**
 * Ouvre la conversation d'un numéro dans la Boîte de réception.
 *
 * Passe par l'événement `callizy:open-conversation`, écouté par
 * DashboardLayout : utilisable hors React (toasts, SDK Twilio).
 * `line` : la conversation de cette ligne (mention, attribution) ; sans
 * ligne, le fil de la personne sur toutes ses lignes.
 */
export function ouvrirConversation(phone: string, line: string | null = null) {
  if (!phone) return
  window.dispatchEvent(
    new CustomEvent('callizy:open-conversation', { detail: { phone, line } }),
  )
}

/** Ouvre le fil de messages d'un collègue dans la Boîte de réception
 * (même porte que `ouvrirConversation`, écoutée par DashboardLayout). */
export function ouvrirCollegue(userId: number) {
  window.dispatchEvent(new CustomEvent('callizy:open-colleague', { detail: { userId } }))
}

/** Ouvre la Boîte de réception sur le filtre « Mentions » (toast d'ouverture). */
export function voirMentions() {
  window.dispatchEvent(new CustomEvent('callizy:open-mentions'))
}
